<template>
  <v-dialog
      persistent
      max-width="980px"
      v-model="showDlg"
  >
    <v-card>
      <v-card-title>
        <span class="toptitle">{{ title }}</span>
        <v-spacer></v-spacer>
        <span>[{{selectedCategories.length}} / {{ allCategories.length }}]</span>
      </v-card-title>

      <v-card-text>
        <v-container>

          <v-card class="scroll justify-start" height="200px" outlined tile>
            <v-chip class="cat-chip"
                v-for="(cat) in allCategories"
                :key="cat.id"
                :active="cat.selected"
                close
                @click:close="onCloseSelected(cat)"
            >{{ cat.name }}</v-chip>
          </v-card>

          <v-card class="d-flex justify-start" height="50px">
            <v-text-field
                v-model="categFilter"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-checkbox
                v-model="checkMesse"
                :label="$t('EASYSELECT_FILTER_FAIR_CHECK')"
            ></v-checkbox>
            <v-text-field
                v-model="messeFilter"
                @click="checkMesse=true"
                :readonly="!checkMesse"
                :style="{opacity: checkMesse?1:0.5}"
            ></v-text-field>
          </v-card>

          <v-card class="scroll" height="300px">
            <div
              v-for="(cat, idx) in filteredCategories"
              tabindex="-1"
              :key="cat.id"
              :data-index="idx"
              label
              :class="cat.selected ? 'cat-item cat-item-active tooltip' : 'cat-item tooltip'"
              @click="onCheckCategory(cat, $event)"
              @keyup.up="onActive(idx-1)"
              @keyup.down="onActive(idx+1)"
              @keypress.space.prevent="onCheckCategory(cat, $event)"
            >
              {{cat.name}}
              <span v-if="cat.desc" class="tooltipdesc"> ? </span>
              <span v-if="cat.desc" class="tooltiptext">{{cat.desc}}</span>
            </div>
          </v-card>

          <v-divider
            vertical
            class="mx-4"
          ></v-divider>

          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header v-slot="{ open }">
                <v-row no-gutters>
                  <v-col cols="4">{{ $t('EASYSELECT_CATEGORY_PANEL_TITLE') }}</v-col>
                  <v-col cols="8" class="text--secondary">
                    <v-fade-transition leave-absolute>
                      <span v-if="open" key="0">
                        <!-- Enter Name and Description -->
                      </span>
                      <span v-else key="1">
                        <!-- {{ trip.location }} -->
                      </span>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-col cols="8">
                    <v-text-field
                      v-model="newCat.name"
                      :placeholder="$t('EASYSELECT_CATEGORY_PANEL_ADD_PROMPT')"
                    ></v-text-field>
                    <v-text-field
                      v-model="newCat.desc"
                      :placeholder="$t('EASYSELECT_CATEGORY_PANEL_TT_PROMPT')"
                    ></v-text-field>
                  </v-col>

                  <v-divider vertical class="mx-4"></v-divider>

                  <v-col cols="3">

                    <v-checkbox
                      v-model="newCat.directly"
                      :label="$t('EASYSELECT_CATEGORY_PANEL_CB_TT')"
                    ></v-checkbox>
                    <br>
                  </v-col>
                </v-row>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="onSaveNewCategory" text color="primary">
                    {{ $t('EASYSELECT_CATEGORY_PANEL_ADD_BT') }}
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="multiple" color="blue darken-1" text @click="onCheckAll">{{$t('EASYSELECT_SELECT_ALL')}}</v-btn>
        <v-btn v-if="multiple" color="blue darken-1" text @click="onUncheckAll">{{$t('EASYSELECT_SELECT_NONE')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="onClose">{{$t('GENERIC_CANCEL')}}</v-btn>
        <v-btn class="btnapply" text @click="onApply">{{$t('GENERIC_APPLY')}}</v-btn>
      </v-card-actions>
    </v-card>

    <Dialog ref="dialog" />
  </v-dialog>
</template>



<script>
  import {mapGetters} from "vuex";
  import Category from '../services/Category';
  import Dialog from './common/Dialog'

  export default {
    name: "CategorySelField",
    components: {
      Dialog
    },
    data: () => ({
      categoryId: 0,
      categFilter: '',
      title: '',
      notifications: false,
      sound: false,
      video: false,
      invites: false,
      showDlg: false,
      prevSelCateg: null,
      // selectedCategories: [],
      allCategories: [],
      multiple: false,
      activeIndex: 0,
      date: null,
      newCat: {
        name: '',
        desc: '',
        directly: false,
      },
      mCategories: [],
      foundCateg: {},
      panel: 1,
    }),

    computed: {
      ...mapGetters(['categories', 'activeContact', 'categoryDict']),
      checkMesse: {
        get() {
          return this.$store.getters.checkMesse;
        },
        set(value) {
          this.$store.commit('setCheckMesse', value);
        },
      },
      messeFilter: {
        get() {
          return this.$store.getters.messeFilter;
        },
        set(value) {
          this.$store.commit('setMesseFilter', value);
        },
      },
      selectedCategories() {
        return this.allCategories.filter(c => c.selected)
      },
      filteredCategories() {
        const lCategFilter = this.categFilter.toLowerCase()
        const lMesseFilter = this.messeFilter.toLowerCase()
        const catArray = this.allCategories.filter( c => {
          const lName = c.name.toLowerCase()
          return (
          (!lCategFilter || lName.indexOf(lCategFilter) >= 0) &&                   // if filter is empty OR cat.name contains the filter
          (!this.checkMesse || !lMesseFilter || lName.indexOf('#') == -1 || lName.substring(0, lName.indexOf('#')).indexOf(lMesseFilter) == 0)  // if not checked Messe.Filter
        )})
        return catArray
      }
    },

    watch: {
      activeIndex(index) {
        this.focusTR(index)
      },
    },

    methods: {
      onCloseSelected(cat) {
        cat.selected = false
      },
      onOpen(categoryId, categById, forceMultiple = false) {
        this.panel = 1
        this.categoryId = categoryId
        this.foundCateg = this.categories.find(c => c.id === categoryId)
        if (this.foundCateg) {
          this.multiple = (this.foundCateg.multiple == 1) || forceMultiple
          if (!this.multiple) {
            if (categById){
               if (typeof categById === 'string') {
                categById = [categById]
              } else if (categById.length > 1) {
                categById = [categById[0]]
              }
            } else {
              categById = []
            }
          }
          this.title = this.foundCateg.name
          this.allCategories = this.foundCateg.children.map( cat => {
            return {
              id: cat.id,
              name: this.categoryDict[cat.id].name,
              desc: this.categoryDict[cat.id].desc,
              selected: categById && categById.includes(cat.id) || false,
            }
          }).sort((a, b) => a.name > b.name? 1 : a.name< b.name? -1 : 0)
          this.prevSelCateg = this.allCategories.find(c => c.selected)
          this.showDlg = true
        }
      },
      onSaveNewCategory() {
        if (!this.newCat.name.trim().length) {
          this.$store.commit('showMessage', {color: 'orange', content: this.$t('EASYSELECT_CATEGORY_PANEL_TITLE')})
          return
        } else if (this.allCategories.includes(c => c.name == this.newCat.name)) {
          this.$store.commit('showMessage', {color: 'orange', content: this.$t('EASYSELECT_CATEGORY_ADD_ERROR_CONTENT')})
          return
        } else {
          const mCat = {
            id: null,
            name: this.newCat.name.trim(),
            desc: this.newCat.desc.trim(),
            selected: this.newCat.directly,
          }
          this.newCat.name = ''
          this.newCat.desc = ''
          this.mCategories.push(mCat)
          const oldCategories = this.allCategories.slice()
          new Category(this.$api).create(this.foundCateg, this.categoryDict, this.mCategories)
            .then((res) => {
              this.mCategories = []
              const newAdded = res.filter(a => !oldCategories.find(c => c.id == a._attributes.id))
              newAdded.forEach(n => {
                const cat = {
                  id: n._attributes.id,
                  name: n._text.trim(),
                  selected: false,
                }
                if (n._attributes.desc) {
                  cat.desc = n._attributes.desc.trim()
                }
                this.allCategories.push(cat)
                this.allCategories.sort((a, b) => a.name > b.name? 1 : a.name< b.name? -1 : 0)
                if (this.newCat.directly) {
                  this.onCheckCategory(cat)
                }
              })
          })
        }
      },
      onApply() {
        this.$emit('select', {
          categoryId: this.categoryId,
          categById: this.allCategories.filter(c => c.selected).map( c => c.id)
        })
        this.showDlg = false
      },
      onClose() {
        this.showDlg = false
      },
      onCheckAll() {
        this.filteredCategories.forEach(c => c.selected = true)
      },
      onUncheckAll() {
        this.filteredCategories.forEach(c => c.selected = false)
      },
      onActive(index) {
        if (index !== null && index >= 0 && index <= this.filteredCategories.length - 1) {
          this.activeIndex = index
        }
      },
      focusTR(index){
        let selected = document.querySelector('[data-index="'+index+'"]')
        if (selected) {
          selected.focus()
        }
      },
      onCheckCategory(cat) {
        if (!this.multiple) {
          if (this.prevSelCateg) {
            this.prevSelCateg.selected = false
          }
          this.prevSelCateg = cat
        }
        cat.selected = !cat.selected
      }
    }
  }
</script>

<style scoped>
  .scroll {
    overflow-y: auto;
  }

  .toptitle {
    margin-left: 20px;
  }

  .cat-chip {
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 2px;
    margin-right: 2px;
  }

  .cat-item {
    padding: 5px;
    margin-top: 1px;
    border: 1px solid darkgray;
    border-radius: 5px;
  }

  .cat-item-active {
    background: rgba(51,153,0,.25);
  }

  /* Tooltip container */
  .tooltip {
    position: relative;
    /* display: inline-block; */
    border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
  }

  /* Tooltip text */
  .tooltip .tooltiptext {
    visibility: hidden;
    width: 405px;
    background-color: rgba(0, 0, 0, 0.514);
    color: #fff;
    text-align: center;
    /* align-self: flex-end; */
    /* padding: 5px 0; */
    border-radius: 6px;
    /* Position the tooltip text - see examples below! */
    position: absolute;
    right: 32px;
    z-index: 1;
  }

  .tooltip .tooltipdesc {
    width: 20px;
    background-color: rgba(0, 0, 0, 0.514);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    position: relative;
    float: right;
    margin-left: 4px;
  }

  /* Show the tooltip text when you mouse over the tooltip container */
  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

.btnapply {
  color:  rgb(49, 103, 128);;
  background-color: rgba(148, 224, 117, 0.623);
}




</style>